import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronRightIcon, XIcon } from 'lucide-react';
import { mainNav } from '../../data/navigation';
import { categories } from '../../data/collections';
const ease = [0.23, 1, 0.32, 1] as const;
export function MobileMenu({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-227" data-mp="1o3gpg6o3tq6g">
      {open && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-228" data-mp="1ja5fvxrwqvau">
          <motion.div className="absolute inset-0 bg-ink/40" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} onClick={onClose} data-id="element-229" data-mp="1j8klc85lfccz" />
          <motion.aside role="dialog" aria-modal="true" aria-label="Menu" className="absolute inset-y-0 left-0 flex w-[86%] max-w-sm flex-col overflow-y-auto bg-canvas" initial={{
        x: '-100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '-100%'
      }} transition={{
        duration: 0.25,
        ease
      }} data-id="element-230" data-mp="5k8g2f6psgx">
            <div className="flex h-16 items-center justify-between border-b border-line px-5" data-id="element-231" data-mp="3ddnbdnbf9lvi">
              <span className="text-lg font-semibold tracking-[0.24em]" data-id="element-232" data-mp="3ib6o2ish1qlc">AMIRA</span>
              <button onClick={onClose} className="grid h-10 w-10 place-items-center rounded-full" aria-label="Menu sluiten" data-id="element-233" data-mp="3mdtimrgj1pm8">
                <XIcon className="h-5 w-5" data-id="element-234" data-mp="3rdpo6v4vhp3w" />
              </button>
            </div>
            <ul className="px-5 py-3" data-id="element-235" data-mp="11nuih45q4ku6">
              {mainNav.map(item => <li key={item.to} data-id="element-236" data-mp="16m5p760q2f86">
                  <Link to={item.to} onClick={onClose} className="flex items-center justify-between border-b border-line py-4 text-lg font-medium" data-id="element-237" data-mp="16le6uww4ydzu">
                    {item.label}
                    <ChevronRightIcon className="h-4 w-4 text-muted" data-id="element-238" data-mp="2yoqj3gzcjpvj" />
                  </Link>
                </li>)}
            </ul>
            <p className="px-5 pt-4 text-xs font-medium text-muted" data-id="element-239" data-mp="3cmykc13f1dci">Per categorie</p>
            <ul className="flex flex-wrap gap-2 px-5 py-3" data-id="element-240" data-mp="37p6iofcyycv4">
              {categories.map(c => <li key={c.id} data-id="element-241" data-mp="2jzlxdptcf3io">
                  <Link to={`/collectie/${c.id}`} onClick={onClose} className="block rounded-full border border-line px-3.5 py-1.5 text-sm" data-id="element-242" data-mp="2ezzn9p8ta3e3">
                    {c.title}
                  </Link>
                </li>)}
            </ul>
            <Link to="/over-amira" onClick={onClose} className="mt-auto border-t border-line px-5 py-5 text-sm text-muted" data-id="element-243" data-mp="2oxdquo9myxoz">
              Over Amira
            </Link>
          </motion.aside>
        </div>}
    </AnimatePresence>;
}